import { Component } from '@angular/core';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-layout',
    imports: [HeaderComponent, FooterComponent, RouterModule, CommonModule],
    templateUrl: './layout.component.html',
    styles: ``
})
export class LayoutComponent {

}
